/**
 * @generated SignedSource<<7b822827a37c6cb00f832284f83c70c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type TxnFlowEnum = "COST" | "INTERNAL" | "REVENUE" | "%future added value";
export type TxnSortEnum = "ACCOUNT" | "AMOUNT" | "CATEGORY" | "COUNTERPARTY" | "DATE" | "DESCRIPTION" | "NATURE" | "%future added value";
export type cashPositionTxnsPanel_Query$variables = {
  classification?: TxnClassificationEnum | null | undefined;
  excludeDistributions?: boolean | null | undefined;
  flow?: TxnFlowEnum | null | undefined;
  month?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  sort?: TxnSortEnum | null | undefined;
  sortDirection?: string | null | undefined;
};
export type cashPositionTxnsPanel_Query$data = {
  readonly transactions: {
    readonly limit: number;
    readonly totalAmount: number;
    readonly totalCount: number;
    readonly txns: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly category: string | null | undefined;
      readonly classification: TxnClassificationEnum | null | undefined;
      readonly counterparty: {
        readonly name: string;
      } | null | undefined;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly internal: boolean;
      readonly kind: string;
      readonly md5: string;
      readonly postingDate: string;
      readonly qboWitnessed: boolean;
      readonly txn: {
        readonly id: string;
      };
    }>;
  };
};
export type cashPositionTxnsPanel_Query = {
  response: cashPositionTxnsPanel_Query$data;
  variables: cashPositionTxnsPanel_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "classification"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeDistributions"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "flow"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v7 = [
  {
    "kind": "Variable",
    "name": "classification",
    "variableName": "classification"
  },
  {
    "kind": "Variable",
    "name": "excludeDistributions",
    "variableName": "excludeDistributions"
  },
  {
    "kind": "Variable",
    "name": "flow",
    "variableName": "flow"
  },
  {
    "kind": "Variable",
    "name": "month",
    "variableName": "month"
  },
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  {
    "kind": "Variable",
    "name": "sortDirection",
    "variableName": "sortDirection"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAmount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limit",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "md5",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internal",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboWitnessed",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classification",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "cashPositionTxnsPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stakeholder",
                "kind": "LinkedField",
                "name": "counterparty",
                "plural": false,
                "selections": [
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "cashPositionTxnsPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stakeholder",
                "kind": "LinkedField",
                "name": "counterparty",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v24/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "14f339a9063a68a35655cf7a72d6687e",
    "id": null,
    "metadata": {},
    "name": "cashPositionTxnsPanel_Query",
    "operationKind": "query",
    "text": "query cashPositionTxnsPanel_Query(\n  $month: String\n  $flow: TxnFlowEnum\n  $classification: TxnClassificationEnum\n  $excludeDistributions: Boolean\n  $perspectiveId: ID\n  $sort: TxnSortEnum\n  $sortDirection: String\n) {\n  transactions(month: $month, flow: $flow, classification: $classification, excludeDistributions: $excludeDistributions, perspectiveId: $perspectiveId, sort: $sort, sortDirection: $sortDirection) {\n    totalCount\n    totalAmount\n    limit\n    txns {\n      txn {\n        id\n      }\n      md5\n      postingDate\n      description\n      amount\n      kind\n      accountNumber\n      internal\n      qboWitnessed\n      classification\n      expenseNature {\n        id\n        name\n      }\n      counterparty {\n        name\n        id\n      }\n      category\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "52ef2996479eb939e1645001007532e1";

export default node;
